import { render, staticRenderFns } from "./UploadOrTakePhoto.vue?vue&type=template&id=709daba1&scoped=true"
import script from "./UploadOrTakePhoto.vue?vue&type=script&lang=js"
export * from "./UploadOrTakePhoto.vue?vue&type=script&lang=js"
import style0 from "./UploadOrTakePhoto.vue?vue&type=style&index=0&id=709daba1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709daba1",
  null
  
)

export default component.exports